export const DATA_TYPES = {
    STRING: "string",
    TIMESTAMP: "timestamp",
    BOOLEAN: "boolean",
    STRING_ARRAY: "string_array",
    OBJECT: "object",
    OBJECT_ARRAY: "object_array",
};

export const VIEW_TYPES = {
    SINGLE_SELECT: "single_select",
    MULTI_SELECT: "multi_select",
    TEXT: "text",
    CHECKBOX: "checkbox",
};
